import { debounce } from 'lodash';
import React, { useEffect, useState } from 'react';

function useScrollCheck({ targetElement }: { targetElement: HTMLElement }) {
  const [scroll, setScroll] = useState(false);

  useEffect(() => {
    const debouncedScroll = debounce(() => {
      if (targetElement.scrollTop >= 50) {
        setScroll(true);
      } else {
        setScroll(false);
      }
    }, 100);

    if (targetElement) {
      targetElement.addEventListener('scroll', debouncedScroll);
      return () => {
        targetElement.removeEventListener('scroll', debouncedScroll);
      };
    }
  }, [targetElement]);

  return { scroll };
}

export default useScrollCheck;
